<div *ngIf="isRadioGroup">
  <label *ngIf="label" id="radio-group-label">Pick your favorite season</label>
  <mat-radio-group
    aria-labelledby="radio-group-label"
    [style.display]=display
    class="radio-group"
    [(ngModel)]="selectedValue">
    <mat-radio-button class="radio-button" *ngFor="let item of radioValue" [value]="item.value" (change)="onChange($event.value)">
      {{item.label}}
    </mat-radio-button>
  </mat-radio-group>
</div>
